import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ExposureTaskDistribution } from 'src/app/models/exposureBySeg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-group-task-distribution',
  templateUrl: './group-task-distribution.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./group-task-distribution.component.scss']
})
export class GroupTaskDistributionComponent implements OnInit {
  @Input() loadingExposureTaskDistribution: boolean = true;
  @Input() exposureTaskDistributionsNew: ExposureTaskDistribution[];

  errorMessage: string = "";

  constructor(
  ) {
    this.errorMessage = ErrorConstants.errorMessage;
  }

  ngOnInit(): void {
  }

  public trackByIndex = trackByIndex;
}
